import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setTotalPrice} from "../actions/price";
import { buildFeeUnitPrices, calculateTotalWithFee, bookingFeeFixed, roundToTwoDecimals } from "../helpers/priceUtils";

const CalculatedPrice = () => {
    const [total, setTotal] = useState(0);
    const [unitPrices, setUnitPrices] = useState([]);
    const dispatch = useDispatch();
    const activeStation = useSelector(state => state.activeStation);
    const { seats } = useSelector(state => state.activeSeats);
    const travelers = useSelector(state => state.travelers);
    const train = useSelector(state => state.trains.currentTrain);
    const fees = useSelector(state => state.tenant);

    useEffect(() => {
        if (!activeStation || !seats) {
            setTotal(0);
            setUnitPrices([]);
            return;
        }

        // One price per passenger + one per first-class seat; the platform fee
        // percentage is rounded per unit (must match the backend fee math).
        const units = buildFeeUnitPrices(travelers, activeStation, seats, train?.firstClassRate || 0);
        setUnitPrices(units);
        setTotal(units.reduce((sum, unitPrice) => sum + unitPrice, 0));
    }, [seats, travelers, activeStation, train]);

    useEffect(() => {
        dispatch(setTotalPrice(total));
    }, [total, dispatch]);

    const totalWithFee = calculateTotalWithFee(total, unitPrices, fees);
    // Ticket total incl. the percentage fee (everything except the fixed booking fee).
    const ticketPrice = roundToTwoDecimals(totalWithFee - bookingFeeFixed(fees));

    return (
        seats &&
        <>
            <h3 className="text-gray-500 text-xs font-medium uppercase tracking-wide pt-4">Pris</h3>
            <div className="mt-3">
                <div className="text-lg font-semibold">
                    {totalWithFee} kr <span className="text-xs font-normal">att betala inkl. moms</span>
                </div>
                <div className="text-sm text-gray-500 mt-1">
                    Biljettpris: {ticketPrice} kr inkl. moms
                </div>
                <div className="text-sm text-gray-500">
                    Bokningsavgift: {bookingFeeFixed(fees)} kr per bokning
                </div>
            </div>
        </>
    );
};

export default CalculatedPrice;
